import React from 'react';
import { CalendarIcon, CheckIcon, ChevronRightIcon, SearchIcon, XIcon } from 'lucide-react';
export function FilterPanel() {
  return <div className="bg-white border-l h-full overflow-y-auto shadow-inner" data-id="element-20">
      <div className="p-5" data-id="element-21">
        <div className="flex items-center justify-between mb-4" data-id="element-22">
          <h3 className="text-lg font-semibold text-gray-900" data-id="element-23">Filters</h3>
          <button className="text-indigo-600 text-sm font-medium hover:text-indigo-800" data-id="element-24">
            Reset All
          </button>
        </div>
        <div className="mb-6" data-id="element-25">
          <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-26">
            Search within results
          </label>
          <div className="relative" data-id="element-27">
            <input type="text" placeholder="Search within results..." className="w-full p-2 pl-8 pr-4 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-indigo-600 focus:border-indigo-600 bg-gray-50" data-id="element-28" />
            <SearchIcon className="absolute left-2.5 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-500" data-id="element-29" />
          </div>
        </div>
        <div className="mb-6" data-id="element-30">
          <div className="flex items-center justify-between mb-1.5" data-id="element-31">
            <label className="block text-sm font-medium text-gray-700" data-id="element-32">
              Keywords
            </label>
            <span className="text-xs text-indigo-600" data-id="element-33">1 selected</span>
          </div>
          <div className="flex flex-wrap gap-2" data-id="element-34">
            <div className="inline-flex items-center bg-indigo-50 text-indigo-800 rounded-full pl-3 pr-1.5 py-1 text-sm" data-id="element-35">
              radiofrequency
              <button className="ml-1 p-0.5 rounded-full hover:bg-indigo-100" data-id="element-36">
                <XIcon size={14} className="text-indigo-600" data-id="element-37" />
              </button>
            </div>
            <button className="inline-flex items-center bg-gray-50 text-gray-700 rounded-full px-3 py-1 text-sm border border-dashed border-gray-300 hover:bg-gray-100" data-id="element-38">
              + Add keyword
            </button>
          </div>
        </div>
        <div className="space-y-5" data-id="element-39">
          <div className="border-b border-gray-200 pb-5" data-id="element-40">
            <div className="flex items-center justify-between mb-1.5" data-id="element-41">
              <label className="block text-sm font-medium text-gray-700" data-id="element-42">
                Payer Name
              </label>
              <ChevronRightIcon size={16} className="text-gray-400" data-id="element-43" />
            </div>
            <div className="relative" data-id="element-44">
              <input type="text" placeholder="Choose Payer" className="w-full p-2 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-indigo-600 focus:border-indigo-600 bg-gray-50" data-id="element-45" />
            </div>
          </div>
          <div className="border-b border-gray-200 pb-5" data-id="element-46">
            <div className="flex items-center justify-between mb-1.5" data-id="element-47">
              <label className="block text-sm font-medium text-gray-700" data-id="element-48">
                State/Region
              </label>
              <ChevronRightIcon size={16} className="text-gray-400" data-id="element-49" />
            </div>
            <div className="relative" data-id="element-50">
              <input type="text" placeholder="Location" className="w-full p-2 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-indigo-600 focus:border-indigo-600 bg-gray-50" data-id="element-51" />
            </div>
          </div>
          <div className="border-b border-gray-200 pb-5" data-id="element-52">
            <div className="flex items-center justify-between mb-1.5" data-id="element-53">
              <label className="block text-sm font-medium text-gray-700" data-id="element-54">
                Policy Category
              </label>
              <ChevronRightIcon size={16} className="text-gray-400" data-id="element-55" />
            </div>
            <div className="flex flex-wrap gap-2" data-id="element-56">
              <button className="inline-flex items-center bg-gray-50 text-gray-700 rounded-full px-3 py-1 text-sm border border-gray-200 hover:bg-gray-100" data-id="element-57">
                Surgery
              </button>
              <button className="inline-flex items-center bg-gray-50 text-gray-700 rounded-full px-3 py-1 text-sm border border-gray-200 hover:bg-gray-100" data-id="element-58">
                Oncology
              </button>
              <button className="inline-flex items-center bg-gray-50 text-gray-700 rounded-full px-3 py-1 text-sm border border-gray-200 hover:bg-gray-100" data-id="element-59">
                Pain Management
              </button>
              <button className="inline-flex items-center bg-gray-50 text-gray-700 rounded-full px-3 py-1 text-sm border border-dashed border-gray-300 hover:bg-gray-100" data-id="element-60">
                + More
              </button>
            </div>
          </div>
          <div className="border-b border-gray-200 pb-5" data-id="element-61">
            <div className="flex items-center justify-between mb-1.5" data-id="element-62">
              <label className="block text-sm font-medium text-gray-700" data-id="element-63">
                Policy Status
              </label>
              <span className="text-xs text-indigo-600" data-id="element-64">2 selected</span>
            </div>
            <div className="space-y-2" data-id="element-65">
              <div className="flex items-center" data-id="element-66">
                <div className="w-5 h-5 rounded border border-indigo-600 bg-indigo-600 flex items-center justify-center mr-2" data-id="element-67">
                  <CheckIcon size={12} className="text-white" data-id="element-68" />
                </div>
                <span className="text-sm" data-id="element-69">Active</span>
              </div>
              <div className="flex items-center" data-id="element-70">
                <div className="w-5 h-5 rounded border border-indigo-600 bg-indigo-600 flex items-center justify-center mr-2" data-id="element-71">
                  <CheckIcon size={12} className="text-white" data-id="element-72" />
                </div>
                <span className="text-sm" data-id="element-73">New</span>
              </div>
              <div className="flex items-center" data-id="element-74">
                <div className="w-5 h-5 rounded border border-gray-300 mr-2" data-id="element-75"></div>
                <span className="text-sm" data-id="element-76">Pending</span>
              </div>
              <div className="flex items-center" data-id="element-77">
                <div className="w-5 h-5 rounded border border-gray-300 mr-2" data-id="element-78"></div>
                <span className="text-sm" data-id="element-79">Draft</span>
              </div>
              <div className="flex items-center" data-id="element-80">
                <div className="w-5 h-5 rounded border border-gray-300 mr-2" data-id="element-81"></div>
                <span className="text-sm" data-id="element-82">Archived</span>
              </div>
            </div>
          </div>
          <div className="border-b border-gray-200 pb-5" data-id="element-83">
            <div className="flex items-center justify-between mb-1.5" data-id="element-84">
              <label className="block text-sm font-medium text-gray-700" data-id="element-85">
                Publish Date
              </label>
              <ChevronRightIcon size={16} className="text-gray-400" data-id="element-86" />
            </div>
            <div className="flex items-center mb-2 space-x-2" data-id="element-87">
              <button className="px-2 py-1 text-xs bg-gray-50 hover:bg-gray-100 rounded border border-gray-200" data-id="element-88">
                1m
              </button>
              <button className="px-2 py-1 text-xs bg-indigo-50 text-indigo-700 rounded border border-indigo-200" data-id="element-89">
                3m
              </button>
              <button className="px-2 py-1 text-xs bg-gray-50 hover:bg-gray-100 rounded border border-gray-200" data-id="element-90">
                6m
              </button>
              <button className="px-2 py-1 text-xs bg-gray-50 hover:bg-gray-100 rounded border border-gray-200" data-id="element-91">
                12m
              </button>
              <button className="px-2 py-1 text-xs bg-gray-50 hover:bg-gray-100 rounded border border-gray-200" data-id="element-92">
                Custom
              </button>
            </div>
            <div className="relative" data-id="element-93">
              <input type="text" placeholder="mm/dd/yyyy" className="w-full p-2 pl-8 border rounded-md text-sm focus:outline-none focus:ring-1 focus:ring-indigo-600 focus:border-indigo-600 bg-gray-50" data-id="element-94" />
              <CalendarIcon size={16} className="absolute left-2.5 top-1/2 transform -translate-y-1/2 text-gray-500" data-id="element-95" />
            </div>
          </div>
        </div>
        <div className="flex space-x-2 mt-6" data-id="element-96">
          <button className="flex-1 py-2.5 bg-indigo-600 text-white rounded-md text-sm font-medium hover:bg-indigo-700 transition-colors" data-id="element-97">
            Apply Filters
          </button>
          <button className="py-2.5 px-4 text-gray-600 border rounded-md text-sm hover:bg-gray-50" data-id="element-98">
            Clear
          </button>
        </div>
      </div>
    </div>;
}